
import SimpleEvent from './../../zviz2/zviz/event';
import {proxy} from './../../zviz2/zviz/functions';


class Nav{

    constructor(){

        this.events = [];

        this.element = document.getElementById('navigation');
        this.items = this.element.getElementsByClassName('expand');
        this.timerId = null;
        this.outTimerId = null;
        this.outElement = null;

        for(let i = 0; i < this.items.length; i++){
            this.events.push(new SimpleEvent(this.items[i], 'mouseover', [this, this.mouseover]));
            this.events.push(new SimpleEvent(this.items[i], 'mouseout', [this, this.mouseout]));
        }

        let mobMenu = document.getElementById('mobileMenu');
        this.events.push(new SimpleEvent(mobMenu, 'click', [this, this.toggleMenu]));
        let active = this.element.getElementsByClassName('active');
        if(active && active[0]){
            for(let c of active[0].childNodes){
                if(c && c.tagName && c.tagName.toLowerCase() == 'a'){
                    mobMenu.innerHTML = c.textContent;
                }
            }
        }

    }

    toggleMenu(event){
        if(this.element.className == 'open'){
            this.element.className = '';
        }else{
            this.element.className = 'open';
        }
    }

    mouseover(event){
        clearTimeout(this.timerId);
        if(this.outElement && this.outElement === event.currentTarget){
            clearTimeout(this.outTimerId);
        }
        this.timerId = setTimeout(proxy([this, this.show, event.currentTarget]), 200);
    }

    show(element){
        for(let i = 0; i < this.items.length; i++){
            let l2 = this.items[i].getElementsByClassName('level2');
            if(l2 && l2[0]){
                l2[0].style.display = 'none';
            }            
        }
        let l2 = element.getElementsByClassName('level2');
        if(l2 && l2[0]){
            l2[0].style.opacity = 0;
            l2[0].style.display = 'block';
            setTimeout(function(){
                l2[0].style.opacity = 1;
            }, 20);
        }
    }

    mouseout(event){
        clearTimeout(this.timerId);
        this.outElement = event.currentTarget;
        this.outTimerId = setTimeout(proxy([this, this.hide, event.currentTarget]), 500);
    }

    hide(element){
        this.outElement = null;
        let l2 = element.getElementsByClassName('level2');
        if(l2 && l2[0]){
            l2[0].style.opacity = 0;
            this.timerId = setTimeout(function(){
                l2[0].style.display = 'none';
            }, 500);
        }
    }

    remove(){
        for(let i = 0; i < this.events.length; i++){
            this.events[i].remove();
        }
        this.events = [];
    }

}

export default Nav;
